<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item>
              <el-input placeholder="操作人"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="操作"></el-input>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="filterData.start" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-table :data="records" border>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="操作" prop="operation"></el-table-column>
        <el-table-column label="操作IP" prop="ip"></el-table-column>
        <el-table-column label="操作时间" prop="created_at"></el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      filterData: {
        name: '',
        start: '',
        end: ''
      },
      records: [
        {
          name: '小A',
          operation: '物业管理',
          ip: '125.43.87.155',
          created_at: '2025-03-01 09:32'
        },
        {
          name: '小A',
          operation: '佣金明细',
          ip: '125.43.87.155',
          created_at: '2025-03-01 09:12'
        }
      ]
    }
  },
  mounted () {
    console.log(this.records)
  },
  methods: {
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
</style>
